import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=adc62b4c&scoped=true&"
import script from "./popUp.vue?vue&type=script&lang=ts&"
export * from "./popUp.vue?vue&type=script&lang=ts&"
import style0 from "./popUp.vue?vue&type=style&index=0&id=adc62b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc62b4c",
  null
  
)

export default component.exports